import { useCallback, useState } from 'react'

const useUniversityProfileDrawer = () => {
	const [isOpen, setIsOpen] = useState(false)
	const [selectedIndex, setSelectedIndex] = useState(0)
	const [items, setItems] = useState([])

	const open = useCallback((wishlistItems, index = 0) => {
		const list = Array.isArray(wishlistItems) ? wishlistItems : []
		if (!list.length) return
		setItems(list)
		setSelectedIndex(Math.min(Math.max(index, 0), list.length - 1))
		setIsOpen(true)
	}, [])

	const close = useCallback(() => {
		setIsOpen(false)
	}, [])

	const navigate = useCallback(nextIndex => {
		setSelectedIndex(nextIndex)
	}, [])

	const selectedItem = items[selectedIndex] || null

	return {
		isOpen,
		items,
		selectedIndex,
		selectedItem,
		open,
		close,
		navigate,
	}
}

export default useUniversityProfileDrawer
